export const SET_ROUTE = 'SET_ROUTE';
export const SET_SETTING_FLAG = 'SET_SETTING_FLAG';
export const SET_LOGPERMISSION_FLAG = 'SET_LOGPERMISSION_FLAG';
export const SET_ACTIVECONTENTTABINDEX = 'SET_ACTIVECONTENTTABINDEX';
export const SET_ACTIVEOBJ ="SET_ACTIVEOBJ";
export const SET_POPUPFLAG = 'SET_POPOPFLAG';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
